export const demandConstants = {
  GET_MY_DEMANDS_REQUEST: "GET_MY_DEMANDS_REQUEST",
  GET_MY_DEMANDS_SUCCESS: "GET_MY_DEMANDS_SUCCESS",
  ADD_FEEDBACK_REQUEST: "ADD_FEEDBACK_REQUEST",
  ADD_FEEDBACK_SUCCESS: "ADD_FEEDBACK_SUCCESS",
  ASK_TO_AGENT_REQUEST: "ASK_TO_AGENT_REQUEST",
  ASK_TO_AGENT_SUCCESS: "ASK_TO_AGENT_SUCCESS",
  DEMANDS_ERROR: "DEMANDS_ERROR",
  CLEAR_SUCCESS_MESSAGE: "CLEAR_SUCCESS_MESSAGE"
};
